(() => {
  let sizes = window.RollMyLogoSizes.keys, formats = window.RollMyLogoSizes.formats;
  const pointPerMM = 72 / 25.4;
  const pageWidth = 792, pageHeight = 612;
  const libraryURL = document.currentScript.dataset.pdfLibrary;
  const repeatMM = diameter => formats[diameter].repeatLengthMm;
  const widthMM = () => 14;
  const repeatInches = diameter => (repeatMM(diameter) / 25.4).toFixed(2);
  const printSizeMM = diameter => `${Number(repeatMM(diameter).toFixed(1))} x ${widthMM()} mm`;
  let dialog, origin, opener, pending = 40, fontPromise, pdfPromise, downloading = false, comparingWidths = false;
  const icon = name => window.lucide.createElement(window.lucide[name]);
  const button = (label, glyph, className) => {
    const element = document.createElement('button');
    element.type = 'button'; element.className = className;
    element.append(icon(glyph), document.createTextNode(label));
    return element;
  };
  const loadFont = () => fontPromise ||= document.fonts.load('900 32px "RML Montserrat"', 'YOUR LOGO').then(fonts => {
    if (!fonts.length) throw new Error('Sample font unavailable');
  }).catch(error => { fontPromise = null; throw error; });

  // All geometry is in PDF points, so the screen and the printed sheet share one physical scale.
  function drawSheet(canvas, selected, scale) {
    if (comparingWidths) return drawWidthSheet(canvas, selected, scale);
    canvas.width = Math.round(pageWidth * scale); canvas.height = Math.round(pageHeight * scale);
    const ctx = canvas.getContext('2d');
    ctx.scale(canvas.width / pageWidth, canvas.height / pageHeight);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, pageWidth, pageHeight);
    const text = (value, x, y, size = 12, weight = 400, color = '#202327') => {
      ctx.font = `${weight} ${size}px Arial, sans-serif`; ctx.fillStyle = color;
      ctx.fillText(value, x, y);
    };
    text('ROLLMYLOGO', 24, 39, 15, 900, '#2457f5');
    text('Roller size comparison', 24, 74, 23, 700);
    text('US Letter  /  Landscape  /  11 x 8.5 in', 24, 98, 12);
    text('Same sample size. Different repeat lengths.', 24, 126, 12);
    text(`Print width: ${(widthMM() / 25.4).toFixed(2)} in (${widthMM()} mm)`, 480, 126, 12);
    sizes.forEach((diameter, index) => {
      const top = 190 + index * 122, repeat = repeatMM(diameter) * pointPerMM;
      const height = widthMM() * pointPerMM;
      if (diameter === selected) {
        ctx.fillStyle = '#eef2ff'; ctx.fillRect(14, top - 54, pageWidth - 28, height + 64);
        ctx.fillStyle = '#2457f5'; ctx.fillRect(14, top - 54, 3, height + 64);
      }
      text(`${formats[diameter].label}  /  ${repeatInches(diameter)} x ${(widthMM() / 25.4).toFixed(2)} in  /  ${printSizeMM(diameter)}`, 24, top - 35, 13, 700);
      ctx.strokeStyle = '#2457f5'; ctx.lineWidth = 0.75;
      ctx.beginPath(); ctx.moveTo(24, top - 7); ctx.lineTo(24, top - 17);
      const end = Math.min(24 + repeat, pageWidth - 24);
      ctx.lineTo(end, top - 17); ctx.lineTo(end, top - 7); ctx.stroke();
      text(`${repeatInches(diameter)} in per full turn${repeat > pageWidth - 48 ? ' (extends beyond this sheet)' : ''}`, 30, top - 21, 10, 400, '#2457f5');
      ctx.save(); ctx.beginPath(); ctx.rect(24, top, pageWidth - 48, height); ctx.clip();
      ctx.fillStyle = '#101112'; ctx.font = '900 32px "RML Montserrat"';
      ctx.textBaseline = 'middle';
      for (let x = 24; x < pageWidth - 24; x += repeat) ctx.fillText('YOUR LOGO', x, top + height / 2);
      ctx.restore();
      ctx.strokeStyle = '#979ca3'; ctx.lineWidth = 0.5; ctx.setLineDash([3, 3]);
      ctx.beginPath(); ctx.moveTo(24, top); ctx.lineTo(pageWidth - 24, top);
      ctx.moveTo(24, top + height); ctx.lineTo(pageWidth - 24, top + height); ctx.stroke(); ctx.setLineDash([]);
    });
    text('Print at 100% / Actual size. Do not fit to page.', 24, 533, 12, 700);
    text('Dashed lines mark the print width; they are not part of the imprint.', 24, 554, 10);
    text('Scale check', 600, 533, 11, 700);
    ctx.strokeStyle = '#202327'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(600, 542); ctx.lineTo(600, 554);
    ctx.moveTo(600, 548); ctx.lineTo(672, 548);
    ctx.moveTo(672, 542); ctx.lineTo(672, 554); ctx.stroke();
    text('1 inch', 684, 552, 11);
    text('Sample artwork shown. The screen preview is scaled to fit your device.', 24, 589, 10);
  }

  function drawWidthSheet(canvas, selected, scale) {
    canvas.width = Math.round(pageWidth * scale); canvas.height = Math.round(pageHeight * scale);
    const ctx = canvas.getContext('2d');
    ctx.scale(canvas.width / pageWidth, canvas.height / pageHeight);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, pageWidth, pageHeight);
    const text = (value, x, y, size = 12, weight = 400, color = '#202327') => {
      ctx.font = `${weight} ${size}px Arial, sans-serif`; ctx.fillStyle = color; ctx.fillText(value, x, y);
    };
    text('ROLLMYLOGO', 24, 36, 15, 900, '#2457f5');
    text('Compare print widths', 24, 67, 23, 700);
    text('US Letter / Landscape / 11 x 8.5 in', 24, 89);
    let top = 140;
    sizes.forEach(key => {
      const format = formats[key], height = format.widthMm * pointPerMM;
      const repeat = format.repeatLengthMm * pointPerMM;
      if (key === selected) { ctx.fillStyle = '#eef2ff'; ctx.fillRect(14, top - 25, pageWidth - 28, height + 30); }
      text(`${format.label} / ${format.widthMm} mm (${(format.widthMm / 25.4).toFixed(2)} in) print width`, 24, top - 10, 13, 700);
      ctx.save(); ctx.beginPath(); ctx.rect(24, top, repeat, height); ctx.clip();
      ctx.fillStyle = '#101112';
      const extraWide = format.label === 'Extra Wide';
      let fontSize = Math.min(height * (extraWide ? .55 : .9), 120);
      ctx.font = `900 ${fontSize}px "RML Montserrat"`;
      fontSize *= Math.min(1, (repeat - 12) / ctx.measureText('YOUR LOGO').width);
      ctx.font = `900 ${fontSize}px "RML Montserrat"`; ctx.textBaseline = 'middle';
      const textWidth = ctx.measureText('YOUR LOGO').width;
      ctx.fillText('YOUR LOGO', 24 + (repeat - textWidth) / 2, top + height * (extraWide ? .35 : .5));
      if (extraWide) {
        const additionalText = 'YOUR ADDITIONAL TEXT';
        let additionalFontSize = height * .25;
        ctx.font = `900 ${additionalFontSize}px "RML Montserrat"`;
        additionalFontSize *= Math.min(1, (repeat - 12) / ctx.measureText(additionalText).width);
        ctx.font = `900 ${additionalFontSize}px "RML Montserrat"`;
        const additionalWidth = ctx.measureText(additionalText).width;
        ctx.fillText(additionalText, 24 + (repeat - additionalWidth) / 2, top + height * .79);
      }
      ctx.restore();
      ctx.strokeStyle = '#979ca3'; ctx.lineWidth = .5; ctx.setLineDash([3, 3]);
      ctx.beginPath(); ctx.moveTo(24, top); ctx.lineTo(24 + repeat, top);
      ctx.moveTo(24, top + height); ctx.lineTo(24 + repeat, top + height); ctx.stroke(); ctx.setLineDash([]);
      top += height + 36;
    });
    text('Print at 100% / Actual size. Do not fit to page.', 24, 535, 12, 700);
    text('Dashed lines mark the print width; they are not part of the imprint.', 24, 556, 10);
    text('Scale check', 600, 535, 11, 700);
    ctx.strokeStyle = '#202327'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(600, 544); ctx.lineTo(600, 556); ctx.moveTo(600, 550); ctx.lineTo(672, 550);
    ctx.moveTo(672, 544); ctx.lineTo(672, 556); ctx.stroke(); text('1 inch', 684, 554, 11);
    text('Sample artwork shown. The screen preview is scaled to fit your device.', 24, 589, 10);
  }

  function render() {
    dialog.querySelectorAll('[name="rml-compare-size"]').forEach(radio => { radio.checked = Number(radio.value) === pending; });
    dialog.querySelector('[data-size-apply]').textContent = `Use ${formats[pending].label}`;
    loadFont().then(() => {
      if (dialog.open) drawSheet(dialog.querySelector('canvas'), pending, 2);
    }).catch(() => { dialog.querySelector('[data-size-status]').textContent = 'The sample could not load. Close this window and try again.'; });
  }

  function configureSizes() {
    comparingWidths = !origin.matches('[data-rml-ready]');
    formats = comparingWidths ? window.RollMyLogoSizes.customFormats : window.RollMyLogoSizes.readyFormats;
    sizes = Object.keys(formats).map(Number);
    dialog.querySelector('.rml-size-guide__options legend').textContent = comparingWidths ? 'Print width' : 'Repeat size';
    dialog.querySelector('.rml-size-guide__sizes').innerHTML = sizes.map(d => `<label><input type="radio" name="rml-compare-size" value="${d}"><span><strong>${formats[d].label}</strong>${comparingWidths ? `<small>${formats[d].widthMm} mm / ${(formats[d].widthMm / 25.4).toFixed(2)} in</small>` : `<small>${repeatInches(d)} in / turn</small><small>${printSizeMM(d)}</small>`}</span></label>`).join('');
    dialog.querySelector('[data-size-width-title]').textContent = comparingWidths ? 'Print widths' : 'Same print width';
    dialog.querySelector('[data-size-width]').textContent = comparingWidths ? '14 / 30 / 50 mm' : `${(widthMM() / 25.4).toFixed(2)} in (${widthMM()} mm)`;
    dialog.querySelector('[data-size-sample]').innerHTML = comparingWidths ? 'Sample: YOUR LOGO<br>Extra Wide: YOUR ADDITIONAL TEXT' : 'Sample: YOUR LOGO<br>Same letter size in every row.';
    dialog.querySelector('canvas').setAttribute('aria-label', comparingWidths ? 'Actual-scale samples on landscape US Letter paper: Standard 14 mm, Wide 30 mm, Extra Wide 50 mm print width with a logo and additional text.' : `Actual-scale sample imprints on landscape US Letter paper. Print width ${widthMM()} mm. Repeat lengths: ${sizes.map(d => `${formats[d].label}: ${printSizeMM(d)}`).join('; ')}. Longer repeats extend beyond the sheet.`);
  }

  async function downloadPDF() {
    if (downloading) return;
    downloading = true;
    const download = dialog.querySelector('[data-size-download]'), status = dialog.querySelector('[data-size-status]');
    download.disabled = true; download.setAttribute('aria-busy', 'true'); status.textContent = '';
    try {
      await loadFont();
      pdfPromise ||= new Promise((resolve, reject) => {
        if (window.PDFLib) { resolve(window.PDFLib); return; }
        const script = document.createElement('script'); script.src = libraryURL;
        script.onload = () => window.PDFLib ? resolve(window.PDFLib) : reject(new Error('PDF library unavailable'));
        script.onerror = () => { script.remove(); reject(new Error('PDF library could not load')); };
        document.head.append(script);
      }).catch(error => { pdfPromise = null; throw error; });
      const { PDFDocument, PrintScaling } = await pdfPromise;
      const pdf = await PDFDocument.create(), sheet = document.createElement('canvas');
      drawSheet(sheet, null, 300 / 72);
      const png = await pdf.embedPng(sheet.toDataURL('image/png'));
      pdf.addPage([pageWidth, pageHeight]).drawImage(png, { x: 0, y: 0, width: pageWidth, height: pageHeight });
      pdf.setTitle('RollMyLogo - actual-size roller comparison');
      pdf.catalog.getOrCreateViewerPreferences().setPrintScaling(PrintScaling.None);
      const url = URL.createObjectURL(new Blob([await pdf.save()], { type: 'application/pdf' }));
      const link = document.createElement('a'); link.href = url; link.download = 'rollmylogo-size-guide-us-letter-landscape.pdf';
      document.body.append(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.warn('RollMyLogo size-guide PDF:', error);
      status.textContent = 'PDF could not be created. Check your connection and try again.';
    } finally {
      downloading = false; download.disabled = false; download.removeAttribute('aria-busy');
    }
  }

  function createDialog() {
    dialog = document.createElement('dialog'); dialog.className = 'rml-size-guide';
    dialog.setAttribute('aria-labelledby', 'rml-size-guide-title');
    dialog.innerHTML = `
      <header class="rml-size-guide__header"><div><h2 id="rml-size-guide-title">Compare sizes on paper</h2><p>US Letter &middot; Landscape &middot; 11 &times; 8.5 in</p></div></header>
      <div class="rml-size-guide__body">
        <figure class="rml-size-guide__paper"><canvas role="img" aria-label="Three sample imprints on landscape US Letter paper, 11 by 8.5 inches. S, M and L share a 14 mm print width."></canvas><figcaption>Scaled to fit your screen. PDF prints at actual size.</figcaption></figure>
        <div class="rml-size-guide__options"><fieldset><legend>Repeat size</legend><div class="rml-size-guide__sizes"></div></fieldset><p><strong data-size-width-title>Same print width</strong><br><span data-size-width></span></p><p data-size-sample>Sample: YOUR LOGO<br>Same letter size in every row.</p></div>
      </div>
      <footer class="rml-size-guide__footer"><p data-size-status role="alert"></p><div class="rml-size-guide__actions"></div></footer>`;
    const close = button('', 'X', 'rml-size-guide__close');
    close.setAttribute('aria-label', 'Close size comparison'); close.title = 'Close size comparison';
    close.autofocus = true; close.addEventListener('click', () => dialog.close());
    dialog.querySelector('header').append(close);
    const download = button('Actual-size PDF', 'Download', 'rml-size-guide__download'); download.dataset.sizeDownload = '';
    download.addEventListener('click', downloadPDF);
    const apply = document.createElement('button'); apply.type = 'button'; apply.dataset.sizeApply = '';
    apply.className = 'rml-size-guide__apply';
    apply.addEventListener('click', () => {
      const control = origin.querySelector(origin.hasAttribute('data-custom-order-only') ? `[data-later-size="${pending}"]` : `[data-roller="${pending}"], [data-ready-diameter][value="${pending}"]`);
      if (!control || control.disabled) {
        dialog.querySelector('[data-size-status]').textContent = 'Please wait until the current design has finished saving.'; return;
      }
      if (control.matches('[data-ready-diameter]')) { control.checked = true; control.dispatchEvent(new Event('change', { bubbles: true })); }
      else control.click();
      dialog.close();
    });
    dialog.querySelector('.rml-size-guide__actions').append(download, apply);
    dialog.addEventListener('change', event => {
      if (event.target.name === 'rml-compare-size') { pending = Number(event.target.value); render(); }
    });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button:not(:disabled), input:checked')];
      const target = event.shiftKey && document.activeElement === controls[0] ? controls.at(-1)
        : !event.shiftKey && document.activeElement === controls.at(-1) ? controls[0] : null;
      if (target) { event.preventDefault(); target.focus(); }
    });
    let startedOutside = false;
    const outside = event => { const box = dialog.getBoundingClientRect(); return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom; };
    dialog.addEventListener('pointerdown', event => { startedOutside = outside(event); });
    dialog.addEventListener('click', event => { if (startedOutside && outside(event)) dialog.close(); startedOutside = false; });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('rml-size-guide-open'); if (opener?.isConnected) opener.focus({ preventScroll: true }); });
    document.body.append(dialog);
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-rml-editor], [data-rml-ready]').forEach(root => {
      if (root.querySelector('.rml-size-compare')) return;
      const placement = root.querySelector('[data-custom-size-guide]') || root.querySelector('[data-roller]')?.closest('.rml-control-group') || root.querySelector('.rml-ready__diameters');
      if (!placement || !window.lucide) return;
      const trigger = button(root.hasAttribute('data-custom-order-only') ? 'Compare actual sizes' : 'Compare sizes on paper', 'Ruler', 'rml-size-compare');
      trigger.addEventListener('click', () => {
        if (!dialog) createDialog();
        if (dialog.open) return;
        origin = root; opener = trigger;
        configureSizes();
        pending = Number(root.querySelector('[data-later-size]:checked, [data-later-size][aria-pressed="true"]')?.dataset.laterSize || root.querySelector('[data-roller][aria-pressed="true"]')?.dataset.roller || root.querySelector('[data-ready-diameter]:checked')?.value || 40);
        dialog.querySelector('[data-size-status]').textContent = '';
        document.documentElement.classList.add('rml-size-guide-open'); dialog.showModal(); render();
      });
      placement.append(trigger);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
